var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowPriorityIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.7488,
    height: 2.32728,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 9.84229 9.83887)",
    fill: "#FBBB00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.42652,
    height: 2.32728,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 6.0874 9.83887)",
    fill: "#FBBB00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.10424,
    height: 2.32728,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 2.33203 9.83887)",
    fill: "#FBBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPriorityIcon);
export default __webpack_public_path__ + "static/media/lowPriorityIcon.08b84ba69cae4f41f07c9ca1d4fcf3b3.svg";
export { ForwardRef as ReactComponent };